import classNames from 'classnames';
import { ComponentProps, FC } from 'react';
import LikeIcon from './LikeIcon';
import { BlockForDeactivatedUser } from '../BlockForDeactivatedUser/BlockForDeactivatedUser';
import Spinner from '../Spinner/Spinner';

type TLikeButtonProps = ComponentProps<'button'> & {
  isActive?: boolean;
  isLoading?: boolean;
  variant?: 'gray' | 'black';
  stroke?: string;
};

const variantClass = {
  gray: 'stroke-gray-600',
  black: 'stroke-black-700',
};

export const LikeButton: FC<TLikeButtonProps> = ({
  className,
  isActive,
  variant = 'gray',
  stroke,
  isLoading,
  ...props
}) => (
  <BlockForDeactivatedUser>
    <button
      className={classNames(
        'flex h-8 w-8 items-center justify-start rounded-full group',
        'active:justify-center active:ml-[-6px] active:mr-[6px] active:bg-red-100',
        {
          'pointer-events-none': isLoading,
        },
        className,
      )}
      {...props}
    >
      {!isLoading && (
        <LikeIcon
          className={classNames(
            {
              '!fill-orange-500 !stroke-orange-500': isActive,
              [variantClass[variant]]: !isActive,
              'animate-pulse opacity-60 pointer-events-none': isLoading,
            },
            'group-hover:!stroke-orange-500',
            [stroke],
          )}
        />
      )}
      {isLoading && <Spinner color="gray" size={5} speedMultiplier={0.7} />}
    </button>
  </BlockForDeactivatedUser>
);
